var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React from 'react';
import styles from './Logo.module.scss';
import logo from 'assets/images/logo.png';
import { devInfoStore } from '@app/Stores/DevInfoStore';
var Logo = /** @class */ (function (_super) {
    __extends(Logo, _super);
    function Logo() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Logo.prototype.render = function () {
        var title = 'TeamGate';
        var environment = '';
        if (devInfoStore.isStaging)
            environment = ' Stage';
        if (devInfoStore.isDemo)
            environment = ' Demo';
        return (React.createElement("div", { className: styles.container },
            React.createElement("div", { className: styles.block },
                React.createElement("img", { src: logo, alt: "" })),
            React.createElement("div", { className: styles.block },
                title,
                React.createElement("span", { style: { color: 'green' } }, environment))));
    };
    return Logo;
}(React.PureComponent));
export { Logo };
